




































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { mapGetters, mapState, mapActions } from "vuex";

import { STORE_KEY, store } from "./_store";

import CommentForm from "./CommentForm.vue";
import TodoForm from "./TodoForm.vue";
import Attachments from "@/components/Controls/Attachments.vue";

@Component({
  computed: {
    ...mapState(STORE_KEY, [
      // 'loading', 'loaded', 'fatalError',
      "loaded",
      "documents",
      "lastMeta"

      // 'document', 'meta'
    ])
    // ...mapGetters(STORE_KEY, [
    //   // 'hasActions', 'canActionToWork', 'canActionConfirmAction', 'disableActionConfirmActionCall', 'canActionToFormation',
    // ]),
  },
  methods: {
    ...mapActions(STORE_KEY, ["addItem", "removeItem"])
  },
  components: {
    CommentForm,
    TodoForm,
    Attachments
  }
})
export default class DocumentFeed extends Vue {
  @Prop() documentId!: string;

  openedForm: string | null = null;

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  public mounted() {
    this.$store.dispatch(`${STORE_KEY}/reset`);
    this.$store.dispatch(`${STORE_KEY}/loadData`, {
      documentId: this.documentId
    });
  }

  public loadingMore = false;
  public loadMore() {
    this.loadingMore = true;

    this.$store
      .dispatch(`${STORE_KEY}/loadMore`, { documentId: this.documentId })
      .finally(() => {
        this.loadingMore = false;
      });
  }

  closeForm() {
    this.openedForm = null;
  }

  saveComment(formData: any) {
    this.$store.dispatch(`${STORE_KEY}/saveComment`, formData).then(() => {
      this.$store.dispatch(`${STORE_KEY}/reset`);
      this.$store.dispatch(`${STORE_KEY}/loadData`, {
        documentId: this.documentId
      });
    });

    this.openedForm = null;
  }

  saveTodo(formData: any) {
    this.$store.dispatch(`${STORE_KEY}/saveTodo`, formData).then(() => {
      this.$store.dispatch(`${STORE_KEY}/reset`);
      this.$store.dispatch(`${STORE_KEY}/loadData`, {
        documentId: this.documentId
      });
    });

    this.openedForm = null;
  }
}
